
import { useSelector } from "react-redux";
import classes from './VerbalScore.module.css';
import VerbalScoreSelect from "./VerbalScoreSelect";
import SwitchToggle from "../../../../UI/SwitchToggle";

const VerbalScore = ({ feedback, changeFeedbackCriterionDisable, changeSelectedAppreciationTextOption , weight , totalScore }) => {
    const { texts, direction, lang } = useSelector(state => state.translate);


    return (
        <div className={`${classes[direction]} ${classes.VerbalScore}`}>
            <div className={classes.Header}>
                <div className={classes.NameHeader}>{texts.criteria}</div>
                <div className={classes.WeightHeader}>{texts.weight}</div>
                <div className={classes.EvaluationHeader}>{texts.evaluation}</div>

            </div>
            {feedback?.feedbackCriteria.map((c, index) =>
                <div key={c.criteria[lang]} className={`${classes.NumericScoreRow} `} >
                    <div className={`${classes.Row} ${!c.disable ? classes.Row : classes.NoScore}`}>
                        <div className={classes.Name}>
                            <div> {c.criteria[lang]}</div>
                            {!c.optional && <div className={classes.Star}> *</div>}
                        </div>
                        <div className={classes.Weight}>{Math.round(c.weight)}%</div>
                        <div className={classes.Select}>
                            <VerbalScoreSelect c={c} criterionIndex={index} changeSelectedAppreciationTextOption={changeSelectedAppreciationTextOption} />
                        </div>
                    </div>
                    <div className={classes.OptinalScoreToggle}>
                        {c.optional &&
                            <SwitchToggle checked={!c.disable} setChecked={() => changeFeedbackCriterionDisable(index)} id={`${index}inUse`} />}
                    </div>
                </div>

            )
            }
            <div className={classes.Footer}>
                <div className={classes.NameHeader}>{texts.weightedScore}</div>
                <div className={classes.WeightHeader}>{weight}%</div>
                <div className={classes.TotalScore}>{totalScore}</div>
            </div>
        </div >
    )
}

export default VerbalScore;